// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--1pMkm","appear":"styles-module--appear--3KnNZ","text":"styles-module--text--2Zt8i","icon":"styles-module--icon--VPsGr"};